import { Box } from '@mui/material';
import logo from '../../assets/logo.png';

type Props = { size?: number };

/** Brand loader: the QuillStack logo pulsing inside a gradient spinning ring. */
const LogoLoader = ({ size = 84 }: Props) => (
  <Box
    role="status"
    aria-label="Loading"
    sx={{
      position: 'relative',
      width: size,
      height: size,
      display: 'grid',
      placeItems: 'center',
      '@keyframes qsLoaderSpin': { to: { transform: 'rotate(360deg)' } },
      '@keyframes qsLoaderPulse': {
        '0%, 100%': { transform: 'scale(1)' },
        '50%': { transform: 'scale(1.12)' },
      },
    }}
  >
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        borderRadius: '50%',
        background: 'conic-gradient(from 0deg, #6226A7, #A855F7, #F6A938, transparent 75%)',
        WebkitMask: 'radial-gradient(farthest-side, transparent calc(100% - 4px), #000 calc(100% - 4px))',
        mask: 'radial-gradient(farthest-side, transparent calc(100% - 4px), #000 calc(100% - 4px))',
        animation: 'qsLoaderSpin 1s linear infinite',
      }}
    />
    <Box
      component="img"
      src={logo}
      alt=""
      sx={{ width: size * 0.56, height: size * 0.56, objectFit: 'contain', animation: 'qsLoaderPulse 1.2s ease-in-out infinite' }}
    />
  </Box>
);

export default LogoLoader;
